import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: "श्री.किशोर वसंतराव कारमोरे  ", designation: " ग्रामपंचायत पिपरा ", phone: "+91 9766366771", imageUrl: "/images/kishor.jpeg" },
  { name: "श्री.कवडू श्रावण कन्नाके", designation: " ग्रामपंचायत पिपरा" , phone: "+91 9307052669", imageUrl: "/images/kavdu.jpeg" },
   { name: "श्री.प्रफुल्ल विठ्ठल मेंघरे", designation: " ग्रामपंचायत पिपरा" , phone: "+91 8806462619", imageUrl: "/images/praful.jpeg" },
  { name: "श्रीमती. वीणा ठाकुरदास उके", designation: " ग्रामपंचायत पिपरा",  phone: "+91 8975715746", imageUrl: "/images/vinabai.jpeg" },
  { name: "सौ. वृंदा सुनील भलावी", designation: " ग्रामपंचायत पिपरा", phone: "+91 9175467759", imageUrl: "/images/vrunda.jpeg" },
  { name: "सौ. सीमा रतिपाल शंभरकर ", designation: " ग्रामपंचायत पिपरा  ",phone: "+91 9373582809", imageUrl: "/images/seema.jpeg" },
  { name: "सौ.कल्पना सुनील गिरडे", designation: " ग्रामपंचायत पिपरा ", phone: "+91 9356785702", imageUrl: "/images/kalpna.jpeg" },
  { name: "सौ. कांचन संजय कोचे", designation: " ग्रामपंचायत पिपरा ", phone: "+91 9960089452", imageUrl: "/images/kanchan.jpeg" },
];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone">📞 {member.phone}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;
